import React from 'react'

import * as RadixSwitch from '@radix-ui/react-switch'
import { twMerge } from 'tailwind-merge'

import { generateId } from '@/helpers/id'

interface Switch {
  label?: string
  id?: string
  className?: string
  thumbClassName?: string
  checked?: boolean
  disabled?: boolean
  onClick?: () => void
  'aria-label'?: string
}

const Switch: React.FC<Switch> = ({
  label,
  id = generateId(),
  className = '',
  thumbClassName = '',
  checked,
  disabled,
  onClick,
  'aria-label': ariaLabel,
}) => (
  <div className="flex items-center">
    {label && (
      <label className="text-white text-sm leading-none pr-[15px]" htmlFor={id}>
        {label}
      </label>
    )}
    <RadixSwitch.Root
      className={twMerge(
        'w-[42px] h-[25px] bg-primary-200 dark:bg-primary-800 rounded-full relative shadow-sm shadow-blackA4 data-[state=checked]:bg-accent-400 dark:data-[state=checked]:bg-accent-400 outline-none cursor-pointer',
        disabled && 'cursor-not-allowed pointer-events-none opacity-60',
        className,
      )}
      id={id}
      checked={checked}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
    >
      <RadixSwitch.Thumb
        className={twMerge(
          'block w-[21px] h-[21px] bg-white rounded-full shadow-sm shadow-blackA4 transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[19px]',
          thumbClassName,
        )}
      />
    </RadixSwitch.Root>
  </div>
)

export default Switch
